import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import pkg from '../../package.json'

export default function initSentry(Vue, router) {
  if (!process.env.VUE_APP_SENTRY_DSN) return
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_ENV || process.env.NODE_ENV,
    release: `client@${pkg.version}`,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', /^\//],
      }),
    ],
    tracesSampleRate: process.env.NODE_ENV === 'development' ? 1.0 : 0.2,
  })
}


